import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import Select from "react-select";
import DatePicker from "react-datepicker-timechange";
import "react-datepicker-timechange/dist/react-datepicker.css";
import checked from "../../img/checked.svg";
import checkedDisabled from "../../img/checked-disabled.svg";
import SpecialDayInput from "./SpecialDayInput";

class AddSpecialDaySelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      empty: true,
      startDate: null,
      endDate: null
    };
  }

  handleSelectChange = async dayTemplate => {
    this.setState({
      value: dayTemplate.id,
      empty: this.state.startDate !== null ? false : true
    });
  };
  handleDateChange = date => {
    if (date === null) {
      this.setState({
        startDate: null,
        endDate: null,
        empty: this.state.value.length > 0 ? false : true
      });
    } else if (this.state.startDate === null && this.state.endDate === null) {
      this.setState({
        startDate: date,
        endDate: null,
        empty: this.state.value.length > 0 ? false : true
      });
    } else if (this.state.startDate !== null && this.state.endDate === null) {
      this.setState({
        //  startDate: date,
        endDate: date,
        empty: this.state.value.length > 0 ? false : true
      });
    } else if (this.state.startDate !== null && this.state.endDate !== null) {
      if (date.isBefore(this.state.startDate)) {
        this.setState({
          startDate: date,
          endDate: this.state.startDate,
          empty: this.state.value.length > 0 ? false : true
        });
      } else if (date.isBefore(this.state.endDate)) {
        this.setState({
          //  startDate: date,
          endDate: date,
          empty: this.state.value.length > 0 ? false : true
        });
      } else {
        this.setState({
          startDate: date,
          endDate: null,
          empty: this.state.value.length > 0 ? false : true
        });
      }
    }
    /*
    if (moment(date).isBefore(moment(this.state.startDate))) {
      this.setState({
        startDate: date,
        endDate: date,
        empty: this.state.value.length > 0 ? false : true
      });
    } else {
      this.setState({
        endDate: date,
        empty: this.state.value.length > 0 ? false : true
      });
    }*/
    /*this.setState({
      startDate: date,
      endDate: date,
      empty: this.state.value.length > 0 ? false : true
    });*/
  };

  handleCreate = async () => {
    const doctorId = this.props.doctorId;
    const date = this.state.startDate.toDate();
    let endDate = this.state.endDate;
    if (endDate !== null) {
      endDate = this.state.endDate.toDate();
    }

    const dayTemplateId = this.state.value;
    await this.props
      .createSpecialDayMutation({
        variables: { date, endDate, doctorId, dayTemplateId }
      })
      .then(() => {
        this.props.refetch();
      })
      .catch(e => {
        console.error("update specialday", e);
      });
    this.setState({
      value: "",
      startDate: null
    });
  };

  render() {
    let save = this.state.empty ? (
      <figure className="image is-32x32">
        <img alt="checkedDisabled" src={checkedDisabled} />
      </figure>
    ) : (
      <figure onClick={this.handleCreate} className="image is-32x32">
        <img alt="checked" src={checked} />
      </figure>
    );
    return (
      <div className="week-day-select">
        <span>
          <DatePicker
            isClearable={true}
            customInput={
              <SpecialDayInput
                startDate={this.state.startDate}
                endDate={this.state.endDate}
              />
            }
            selected={this.state.startDate}
            selectsEnd
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleDateChange}
            shouldCloseOnSelect={false}
          />
        </span>
        <Select
          value={this.state.value}
          onChange={v => this.handleSelectChange(v)}
          options={this.props.options}
          valueKey="id"
          clearable={false}
          placeholder="Sélectionnez un template"
          labelKey="name"
          wrapperStyle={{
            width: "80%"
          }}
        />
        <span>{save}</span>
      </div>
    );
  }
}

const CREATE_SPECIALDAY_MUTATION = gql`
  mutation CreateSpecialDayMutation(
    $date: DateTime!
    $endDate: DateTime
    $doctorId: ID!
    $dayTemplateId: ID!
  ) {
    createSpecialDay(
      date: $date
      endDate: $endDate
      doctorId: $doctorId
      dayTemplateId: $dayTemplateId
    ) {
      id
    }
  }
`;

/*export default graphql(GET_DAYTEMPLATE_QUERY, {
  name: "getDayTemplate",
  options: ({ templateId }) => ({ variables: { templateId } })
})(EditTemplate);*/
export default graphql(CREATE_SPECIALDAY_MUTATION, {
  name: "createSpecialDayMutation"
})(AddSpecialDaySelect);



// WEBPACK FOOTER //
// ./src/components/utilities/AddSpecialDaySelect.js